import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Lock, Mail, AlertCircle } from 'lucide-react';
export function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const {
    login
  } = useAuth();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      const success = await login(email, password);
      if (success) {
        navigate('/');
      } else {
        setError('Invalid email or password');
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };
  return <div className="min-h-screen bg-[#F5F1EB] flex items-center justify-center p-4" data-id="element-1229">
      <div className="w-full max-w-md" data-id="element-1230">
        <div className="bg-white rounded-3xl shadow-lg p-10" data-id="element-1231">
          {/* Logo */}
          <div className="flex justify-center mb-8" data-id="element-1232">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/evhqqTRQQymTnZaP7eqEfR/Asika_Icon.svg" alt="Asika Logo" className="h-16 w-auto" data-id="element-1233" />
          </div>

          {/* Title */}
          <div className="text-center mb-8" data-id="element-1234">
            <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-1235">
              Welcome Back
            </h1>
            <p className="text-gray-600" data-id="element-1236">Sign in to access your dashboard</p>
          </div>

          {/* Error Message */}
          {error && <div className="mb-6 p-4 bg-red-50 border-2 border-red-200 rounded-2xl flex items-center gap-2 text-red-800" data-id="element-1237">
              <AlertCircle size={16} data-id="element-1238" />
              <span className="text-sm" data-id="element-1239">{error}</span>
            </div>}

          {/* Login Form */}
          <form onSubmit={handleSubmit} className="space-y-5" data-id="element-1240">
            <div data-id="element-1241">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1242">
                Email Address
              </label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="asika-input w-full" placeholder="your.email@example.com" required data-id="element-1243" />
            </div>

            <div data-id="element-1244">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1245">
                Password
              </label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="asika-input w-full" placeholder="••••••••" required data-id="element-1246" />
            </div>

            <button type="submit" disabled={isLoading} className="asika-button w-full disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-1247">
              {isLoading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          {/* Demo Credentials */}
          <div className="mt-8 p-4 bg-blue-50 rounded-2xl border-2 border-blue-100" data-id="element-1248">
            <p className="text-xs text-blue-800 font-medium mb-2" data-id="element-1249">
              Demo Credentials:
            </p>
            <p className="text-xs text-blue-700" data-id="element-1250">Email: admin@novocuris.com</p>
            <p className="text-xs text-blue-700" data-id="element-1251">Password: admin123</p>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-6 text-sm text-gray-600" data-id="element-1252">
          <p data-id="element-1253">Patient Registration System v1.0</p>
        </div>
      </div>
    </div>;
}
export default Login;